import Vue from 'vue'
import DIC from '@/index/dictionary'
import _ from 'underscore'

Vue.filter('sex', function (value) {
  let a = [
    { value: 0, label: '未知' },
    { value: 1, label: '男' },
    { value: 2, label: '女' }
  ]
  let f = _.findWhere(a, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})

Vue.filter('date', function (value) {
  return value ? value.substr(0, 10) : ''
})
Vue.filter('dateTime', (d, f) => {
  return (d ? d.substr(0, 16) : (f || d))
})
Vue.filter('time', function (value) {
  if (value) {
    if (value.length === 8) {
      return value.substr(0, 5)
    } else if (value.length === 19) {
      return value.substr(11, 5)
    }
  } else {
    return ''
  }
})
Vue.filter('week', (s) => {
  let t = new Date()
  s = s.replace(/-/g, '/')
  t.setTime(Date.parse(s))
  let d = t.getDay()
  let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  return weeks[d]
})
Vue.filter('oss', function (value, w, h, r) {
  let cb = function (v) {
    if (v === undefined) {
      w = w || 60
      return 'https://via.placeholder.com/' + w
    } else if (v.indexOf('http://') > -1 || v.indexOf('https://') > -1) {
      return v
    } else {
      if (w !== undefined) {
        // w = Math.round(w * devicePixelRatio)
        let s = `${DIC.OSS}${v}?x-oss-process=image/resize,w_${w}`
        if (h !== undefined) {
          s = `${DIC.OSS}${v}?x-oss-process=image/resize,m_fixed,h_${h},w_${w}`
        }
        if (r !== undefined) {
          s += `/circle,r_${w}`
        }
        return s
      }else {
        let s = `${DIC.OSS}${v}!zip`
        return s
      }
    }
  }
  // console.log('value', value)
  if (_.isArray(value)) {
    return cb(value[0])
  } else {
    if (value && value.indexOf(',') > -1) {
      value = value.split(',')
      return cb(value[0])
    } else {
      return cb(value)
    }
  }
})
Vue.filter('videoSnapshot', function (value, s, h) {
  s = s || 1
  let strH = (h !== undefined) ? `,h_${h}` : ''
  if (value === undefined || value.indexOf('http://') > -1 || value.indexOf('https://') > -1) {
    return value
  } else {
    return `${DIC.OSS}${value}?x-oss-process=video/snapshot,t_${s}000,f_jpg${strH},m_fast`
  }
})

Vue.filter('placeholder', (d, s) => {
  s = s || '-'
  return (d === undefined || d === '') ? s : d
})
Vue.filter('prefix', (d, s) => {
  return `${s}${d}`
})
Vue.filter('round', (d) => {
  if (_.isNaN(d)) {
    return 0
  } else {
    return Math.round(d)
  }
})
Vue.filter('toFixed', (d = 0, num = 2) => {
  return d.toFixed(num)
})
Vue.filter('price', (d = 0) => {
  return Number((d / 100).toFixed(2))
})
Vue.filter('goodsStatus', function (value) {
  let f = _.findWhere(DIC.GOODS_STATUS, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})
Vue.filter('orderStatus', function (value) {
  let f = _.findWhere(DIC.ORDER_STATUS, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})

Vue.filter('pOrderStatus', function (value) {
  let f = _.findWhere(DIC.PICK_ORDER_STATUS, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})

Vue.filter('orderRecordStatus', function (value) {
  let f = _.findWhere(DIC.ORDER_RECORD_STATUS, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})
Vue.filter('row', function (d, n, m) {
  let r = ''
  if (d !== undefined) {
    let l = (m !== undefined) ? m : d.length / n
    let a = []
    if (m !== undefined && d.length <= m) {
      r = d
    } else {
      for (var i = 0; i < n; i++) {
        if (i === n - 1) {
          a.push(d.substr(l * i).trim())
        } else {
          a.push(d.substr(l * i, l).trim())
        }
      }
      _.each(a, (t) => {
        r += `<div>${t}</div>`
      })
    }
  }
  return r
})
Vue.filter('articleType', function (value) {
  let f = _.findWhere(DIC.ARTICLE_TYPE, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})
Vue.filter('payChannel', function (value) {
  let f = _.findWhere(DIC.PAY_CHANNEL, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})
Vue.filter('payType', function (value) {
  let f = _.findWhere(DIC.PAY_TYPE, { value })
  if (f && f.label) {
    return f.label
  } else {
    return ''
  }
})
